import React, { useEffect, useState } from 'react';

import {
  Container,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  Button,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText
} from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from '../../../components/Pagination';
import VoiceService from '../service';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';

const VoiceList = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);

  const [voiceMail, setVoiceMail] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);

  useEffect(() => {
    getVoiceMail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getVoiceMail = (selectedPage = 1) => {
    VoiceService.getAll(selectedPage, 10)
      .then((res) => {
        const { data, totalRegisters } = res.data;
        const newActivePage = selectedPage || activePage;

        setVoiceMail(data);
        setQuantity(totalRegisters);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possivel listar as voiceMails', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handlePageChange = (activePage) => {
    getVoiceMail(activePage);
  };

  function getVoiceSeach(event, selectedPage = 1) {
    const login = localStorage.getItem('login');
    VoiceService.getAllSeach(selectedPage, 10, event.target.value, false, login)
      .then((res) => {
        const { data, totalRegisters } = res.data;
        const newActivePage = selectedPage || activePage;
        setVoiceMail(data);
        setQuantity(totalRegisters);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possivel listar as voiceMails', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  }

  function deleteVoice(voice_id) {
    VoiceService.delete(voice_id)
      .then(() => {
        toast.success('voiceMail excluido com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        getVoiceMail();
      })
      .catch(() => {
        toast.error('Ocooreu um erro!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getVoiceMail();
      });
  }

  const controlDelete = (id) => {
    setidResource(id);
    setOpenModalConfirmation(true);
  };

  function handleUpdate(id) {
    history.push(`voicemail/form/${id}`);
  }

  return (
    <>
      <SimpleHeader
        setCreate="/admin/voicemail/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Voicemails</h3>
                </CardHeader>
                <CardBody>
                  {/* <small className="text text-muted font-weight-bold">
                    Buscar setor
                  </small> */}
                  <Row>
                    <Col md="11">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Busque por Nome, Email ou Ramal"
                          type="text"
                          onChange={(event) => getVoiceSeach(event)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={voiceMail}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'email',
                      text: 'Email',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'extension_id',
                      text: 'Ramal',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },

                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="info"
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },

                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => controlDelete(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deleteVoice}
        message={'Tem certeza que deseja excluir este voiceMail?'}
      />
    </>
  );
};

export default VoiceList;
